class ProductSliderWithThumbnails {
    constructor() {

        this.selectors = {
            container: '[data-js-product-swiper-slider-container]',
            productSlider: '[data-js-product-swiper-slider]',
            productSliderThumbnails: '[data-js-product-swiper-thumbnails]',
            productArrowNext: "[data-js-product-slider-arrow-next]",
            productArrowPrev: "[data-js-product-slider-arrow-prev]",
            productPagination: "[data-js-product-slider-pagination]"
        }

        this.init();
    }


    init() {
        try {
            import(flu.chunks.swiper).then((ref) => this.swiperLoaded(ref));
        }
        catch (error) {
            console.error('Error loading Swiper', error);
        }

    }

    swiperLoaded(_ref) {

        if (!_ref.Swiper) {
            console.error('Swiper is not defined');
            return null;
        }
        this.swiper = _ref.Swiper;
        this.Navigation = _ref.Navigation;
        this.Pagination = _ref.Pagination;
        this.Thumbs = _ref.Thumbs;

        this.defineVariables();

        if (!this.containerEl || !this.sliderEl || !this.thumbnailsEl) {
            return null;
        }

        this.initThumbnailsSlider();
        this.initSlider();

    }

    defineVariables() {
       this.containerEl =
           document.querySelector(this.selectors.container);
       this.sliderEl =
           document.querySelector(this.selectors.productSlider);
       this.thumbnailsEl =
           document.querySelector(this.selectors.productSliderThumbnails);
    }

    initSlider() {
       this.slider = new this.swiper(this.sliderEl, {
           modules: [this.Navigation, this.Thumbs, this.Pagination],
           slidesPerView: 1,
           navigation: {
               nextEl: this.containerEl.querySelector(
                   this.selectors.productArrowNext),
               prevEl: this.containerEl.querySelector(
                   this.selectors.productArrowPrev),
           },
           pagination: {
               el: document.querySelector(
                   this.selectors.productPagination),
               type: "fraction",
           },
           thumbs: {
               swiper: this.thumbnails
           },
       });
    }

    initThumbnailsSlider() {
     this.thumbnails = new this.swiper(this.thumbnailsEl, {
         modules: [this.Navigation, this.Thumbs,this.Pagination],
         slidesPerView: "auto",
         grabCursor: true,
         autoHeight: true,
         direction: "vertical",
         spaceBetween: 8
      });
    }
}


if (!window.customElements.get("product-delivery-info")) {

    class ProductDeliveryInfo extends HTMLElement {

        constructor() {
            super()

            console.log('ProductDeliveryInfo')
        }

        connectedCallback() {

        }
    }

    customElements.define("product-delivery-info", ProductDeliveryInfo)
}




(() => {
    new ProductSliderWithThumbnails;
})();


